module.exports = __webpack_public_path__ + "Roboto-Bold.470488ec54d9a21c8565.eot";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Roboto-Bold.eot
// module id = ../../../../../src/assets/fonts/Roboto-Bold.eot
// module chunks = main